import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const sitesUiSlice = createSlice({
  name: 'sites-ui',
  initialState: { ...baseUiInitialState, idsToCorrelate: [] as string[] },
  reducers: {
    ...baseUiReducers,
    setIdsToCorrelate: (state, { payload }: PayloadAction<string[]>) => {
      state.idsToCorrelate = payload.map((id) => id.toString());
    },
    upsertIdToCorrelate: (state, { payload: idToAdd }: PayloadAction<string>) => {
      if (state.idsToCorrelate.includes(idToAdd)) return;

      state.idsToCorrelate = [...state.idsToCorrelate, idToAdd].slice(-3);
    },
  },
});
